let frag = `
void main(){
  gl_FragColor = vec4(120.0 / 255.0, 114.0 / 255.0, 118.0 / 255.0, 1.0);
}`

export default frag
